export const inputSeats = [[3, 2], [4, 3], [2, 3], [3, 4]];
export const inputPassengers = 30;
